import { render, staticRenderFns } from "./Birthlist.vue?vue&type=template&id=6daa01d3&"
import script from "./Birthlist.vue?vue&type=script&lang=js&"
export * from "./Birthlist.vue?vue&type=script&lang=js&"
import style0 from "./Birthlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports